<template>
    <Form ref="formRef" @submit="onSubmit">
        <div class="modal-header">
            <h4 class="modal-title">
                Generar tabla de amortización para Pagos
            </h4>
            <!-- data-dismiss="modal" -->
            <button type="button" class="close" aria-label="Close" @click="closeModal">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="card-body">
                <!-- Estado de carga -->
                <div v-if="isLoading" class="alert alert-info text-center">
                    <i class="fa fa-spinner fa-spin"></i> Procesando...
                </div>

                <!-- Mensaje de error -->
                <div v-if="error" class="alert alert-danger">
                    <i class="fa fa-exclamation-triangle"></i> {{ error }}
                    <button type="button" class="close" @click="clearError">
                        <span>&times;</span>
                    </button>
                </div>

                <div class="form-group">
                    <label for="ProspectReferenceNumber">Cliente:</label>
                    <PrimaryButton class="btn-success ml-2" @click.prevent="changeModalContent(2)"
                        :disabled="isLoading">
                        <i class="fa fa-search"></i> Buscar
                    </PrimaryButton>
                    <div class="row mt-2">
                        <Field v-model="getProspectusReferenceNumber" type="text" class="form-control col-sm-4"
                            name="ProspectReferenceNumber" rules="required" disabled />
                        <Field v-model="getProspectFullname" type="text" class="form-control col-sm-8"
                            name="ProspectFullname" disabled />
                        <ErrorMessage name="ProspectReferenceNumber" class="input-error" />
                    </div>
                </div>

                <div class="form-group">
                    <label for="branchOfficeId">Matriz y/o Sucursales:</label>
                    <Field v-model="getBranchOffice" type="text" class="form-control" name="branchOfficeId" disabled />
                </div>

                <div class="form-group">
                    <label for="disposition">Disposición:</label>
                    <PrimaryButton class="btn-success ml-2" @click.prevent="changeModalContent(3)"
                        :disabled="isLoading || !props.client?.creditFacility?.prospectus?.prospectusId">
                        <i class="fa fa-search"></i> Buscar
                    </PrimaryButton>
                    <div class="row mt-2">
                        <Field v-model="getDisposition" type="text" class="form-control col-sm-4"
                            name="DispositionReferenceNumber" rules="required" disabled />
                        <Field v-model="getDisburmentStatus" type="text" class="form-control col-sm-8"
                            name="statusDisposition" disabled />
                        <ErrorMessage name="DispositionReferenceNumber" class="input-error" />
                    </div>
                </div>

                <div class="row">
                    <div class="col-6">
                        <div class="form-group">
                            <label for="quotationR">Cotización:</label>
                            <Field v-model="getQuotation" type="text" class="form-control"
                                name="QuotationReferenceNumber" rules="required" disabled />
                            <ErrorMessage name="QuotationReferenceNumber" class="input-error" />
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-group">
                            <label for="score">Monto autorizado:</label>
                            <Field v-model="getCreditAmount" type="text" class="form-control" name="creditAmount"
                                disabled />
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <label for="product">Producto:</label>
                    <div class="row mt-2">
                        <Field v-model="getProduct" type="text" class="form-control col-sm-4"
                            name="ProductReferenceNumber" rules="required" disabled />
                        <Field v-model="getProductType" type="text" class="form-control col-sm-8" name="productType"
                            disabled />
                        <ErrorMessage name="ProductReferenceNumber" class="input-error" />
                    </div>
                </div>

                <div class="form-group">
                    <label for="description">Descripción:</label>
                    <Field v-model="getProductDescription" type="text" class="form-control" name="descriptionProduct"
                        disabled />
                    <ErrorMessage name="DescripctionProduct" class="input-error" />
                </div>

                <div class="row">
                    <div class="col-6">
                        <div class="form-group">
                            <label for="creditScoreR">Calificación:</label>
                            <Field v-model="getCreditScoreReference" type="text" class="form-control"
                                name="creditScoreReference" disabled />
                            <ErrorMessage name="CreditScoreReferenceNumber" class="input-error" />
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-group">
                            <label for="score">Score:</label>
                            <Field v-model="getScore" type="text" class="form-control" name="score" disabled />
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <label for="disposition">Solicitud:</label>
                    <div class="row mt-2">
                        <Field v-model="getLoanApplication" type="text" class="form-control col-sm-4"
                            name="LoanApplicationReferenceNumber" rules="required" disabled />
                        <Field v-model="getPersonType" type="text" class="form-control col-sm-8" name="personType"
                            disabled />
                        <ErrorMessage name="LoanApplicationReferenceNumber" class="input-error" />
                    </div>
                </div>

                <div class="form-group">
                    <label for="ProspectReferenceNumber">Tabla de amortización de pagos:</label>
                    <PrimaryButton class="btn-success ml-2" @click.prevent="changeModalContent(4)"
                        :disabled="isLoading || !props.disposition?.id">
                        <i class="fa fa-search"></i> Buscar
                    </PrimaryButton>
                </div>

                <template v-if="hasPaymentData">
                    <div class="row">
                        <div class="col-12">
                            Captura de datos de Pago
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <div class="table-container">
                                <table class="table table-hover amortization-table text-nowrap">
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th colspan="2">FECHA</th>
                                            <th></th>
                                            <th>SALDO INICIAL</th>
                                            <th colspan="6" class="text-center">GENERADO</th>
                                            <th colspan="7" class="text-center">A PAGAR c/IVA</th>
                                            <th>SALDO FINAL</th>
                                            <th colspan="11" class="text-center">Informativo: Detalle del Pago
                                                Restante</th>
                                        </tr>
                                        <tr>
                                            <th># Pago</th>
                                            <th>Vencimiento</th>
                                            <th>Pagado</th>
                                            <th>Hora de Pago</th>
                                            <th>Capital</th>
                                            <th>Interés</th>
                                            <th>IVA</th>
                                            <th>Comisiones</th>
                                            <th>IVA</th>
                                            <th>Mora</th>
                                            <th>IVA</th>
                                            <th>Capital</th>
                                            <th>Interés</th>
                                            <th>Comisiones</th>
                                            <th>Mora</th>
                                            <th>Pago Realizado</th>
                                            <th>Pago Restante</th>
                                            <th>Pago Total</th>
                                            <th>Saldo Insoluto</th>
                                            <th>Capital</th>
                                            <th>Interés</th>
                                            <th>Intereses sin IVA</th>
                                            <th>IVA</th>
                                            <th>Mora</th>
                                            <th>Mora Sin IVA</th>
                                            <th>IVA</th>
                                            <th>Comisiones</th>
                                            <th>Comisiones Sin IVA</th>
                                            <th>IVA</th>
                                            <th>Pago Restante</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(amortization, index) in getTableData" :key="amortization.id">
                                            <!--1 # Pago-->
                                            <td>
                                                {{ amortization.installmentNumber }}
                                            </td>
                                            <!--2 Vencimiento-->
                                            <td>
                                                {{ filters.formatDateView(amortization.dueDate) }}
                                            </td>
                                            <!--3 Pagado-->
                                            <td>
                                                <template v-if="isClickCalculate.normal || isClickCalculate.moratorio">
                                                    <template v-if="pesosFormat(pagoRestanteApagarUpdate(amortization)) === pesosFormat(0)">
                                                        {{ filters.formatDateSNTimeView(formRef.values.paymentDate) }}
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <template v-if="isClickCalculate.anticipado && amortization.remainingPaymentA === 0">
                                                        {{ filters.formatDateSNTimeView(formRef.values.paymentDate) }}
                                                    </template>
                                                    <template v-if="amortization.amortizationPayment.length > 0">
                                                        <template
                                                            v-if="amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentType.id === 3 && amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentRemaining === 0">
                                                            {{ filters.formatDateSNTimeView(amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentDate) }}
                                                        </template>
                                                        <template v-if="pesosFormat(pagoRestanteApagar(amortization)) === pesosFormat(0)">
                                                            {{
                                                                /**Nota: Siempre debemos obtener el ultimo registro del array para mostrar en la fila */
                                                                filters.formatDateSNTimeView(amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentDate)
                                                            }}
                                                        </template>
                                                    </template>
                                                </template>
                                            </td>
                                            <!--4 Hora de Pago	-->
                                            <td>
                                                <template v-if="isClickCalculate.normal || isClickCalculate.moratorio">
                                                    <template v-if="pesosFormat(pagoRestanteApagarUpdate(amortization)) === pesosFormat(0)">
                                                        {{ formRef.values.paymentTime }}
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <template v-if="isClickCalculate.anticipado && amortization.remainingPaymentA === 0">
                                                        {{ formRef.values.paymentTime }}
                                                    </template>
                                                    <template v-if="amortization.amortizationPayment.length > 0">
                                                        <template
                                                            v-if="amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentType.id === 3 && amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentRemaining === 0">
                                                            {{ amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentTime }}
                                                        </template>
                                                        <template v-if="pesosFormat(pagoRestanteApagar(amortization)) === pesosFormat(0)">
                                                            {{
                                                                /**Nota: Siempre debemos obtener el ultimo registro del array para mostrar en la fila */
                                                                amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentTime
                                                            }}
                                                        </template>
                                                    </template>
                                                </template>
                                            </td>
                                            <!--5 Capital-->
                                            <td>
                                                <template
                                                    v-if="amortization.amortizationPayment.length > 0 && amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentType.id === 3 && amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentRemaining === 0">
                                                    {{ pesosFormat(0) }}
                                                </template>
                                                <template v-else>
                                                    {{ pesosFormat(amortization.initialCapital) }}
                                                </template>
                                            </td>
                                            <!--6 Interés-->
                                            <td>
                                                <template v-if="amortization.amortizationPayment.length > 0 && amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentType.id === 3">
                                                    <template
                                                        v-if="amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentRemaining === 0">
                                                        {{ pesosFormat(0) }}
                                                    </template>
                                                    <template v-else>
                                                        {{ pesosFormat(amortization.amortizationPayment[amortization.amortizationPayment.length - 1].interestA) }}
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    {{ pesosFormat(amortization.interest) }}
                                                </template>
                                            </td>
                                            <!--7 IVA-->
                                            <td>
                                                <template v-if="amortization.amortizationPayment.length > 0 && amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentType.id === 3">
                                                    <template
                                                        v-if="amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentRemaining === 0">
                                                        {{ pesosFormat(0) }}
                                                    </template>
                                                    <template v-else>
                                                        {{ pesosFormat(amortization.amortizationPayment[amortization.amortizationPayment.length - 1].taxA) }}
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    {{ pesosFormat(amortization.tax) }}
                                                </template>
                                            </td>
                                            <!--8 Comisiones-->
                                            <td>
                                                <template
                                                    v-if="amortization.amortizationPayment.length > 0 && amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentType.id === 3 && amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentRemaining === 0">
                                                    {{ pesosFormat(0) }}
                                                </template>
                                                <template v-else>
                                                    {{ pesosFormat(amortization.commissions) }}
                                                </template>
                                            </td>
                                            <!--9 IVA-->
                                            <td>
                                                <template
                                                    v-if="amortization.amortizationPayment.length > 0 && amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentType.id === 3 && amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentRemaining === 0">
                                                    {{ pesosFormat(0) }}
                                                </template>
                                                <template v-else>
                                                    {{ pesosFormat(amortization.taxes) }}
                                                </template>
                                            </td>
                                            <!--10 Mora-->
                                            <td>
                                                {{ pesosFormat(totalLatePaymentGeneration(amortization)) }}
                                            </td>
                                            <!--11 IVA-->
                                            <td>
                                                {{ pesosFormat(taxGeneratedValueAdded(amortization)) }}
                                            </td>
                                            <!--A PAGAR c/IVA-->
                                            <!--12 Capital-->
                                            <td>
                                                <template v-if="amortization.amortizationPayment.length > 0 && amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentType.id === 3">
                                                    <template
                                                        v-if="amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentRemaining === 0">
                                                        {{ pesosFormat(0) }}
                                                    </template>
                                                    <template v-else>
                                                        <!-- {{ pesosFormat(amortization.amortizationPayment[amortization.amortizationPayment.length - 1].capitalPA) }} -->
                                                        {{ pesosFormat(calCapitalPA(amortization)) }}
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    {{ pesosFormat(amortization.capital) }}
                                                </template>
                                            </td>
                                            <!--13 Interés-->
                                            <td>
                                                <template
                                                    v-if="amortization.amortizationPayment.length > 0 && amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentType.id === 3">
                                                    <template v-if="amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentRemaining === 0">
                                                        {{ pesosFormat(0) }}
                                                    </template>
                                                    <template v-else>
                                                        {{ pesosFormat(amortization.amortizationPayment[amortization.amortizationPayment.length - 1].interestPA) }}
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    {{ pesosFormat(interesApagar(amortization)) }}
                                                </template>
                                            </td>
                                            <!--14 Comisiones-->
                                            <td>
                                                <template v-if="amortization.amortizationPayment.length > 0">
                                                    {{
                                                        /**Nota: Siempre debemos obtener el ultimo registro del array para mostrar en la fila */
                                                        pesosFormat(amortization.amortizationPayment[amortization.amortizationPayment.length - 1].commissionsToPay)
                                                    }}
                                                </template>
                                                <template v-else>
                                                    {{ pesosFormat(amortization.taxes + amortization.commissions ) }}
                                                </template>
                                            </td>
                                            <!--15 Mora-->
                                            <td>
                                                {{ pesosFormat(totalLatePaymentApagar(amortization))}}
                                            </td>
                                            <!--16 Pago Realizado-->
                                            <td>
                                                {{ pesosFormat(calPagoRealizado(amortization)) }}
                                            </td>
                                            <!--17 Pago Restante-->
                                            <td>
                                                <template v-if="isClickCalculate.normal || isClickCalculate.moratorio">
                                                    {{ pesosFormat(pagoRestanteApagarUpdate(amortization)) }}
                                                </template>
                                                <template v-else>
                                                    <template v-if="isClickCalculate.anticipado && amortization.remainingPaymentA !== undefined">
                                                        {{ pesosFormat(amortization.remainingPaymentA) }}
                                                    </template>
                                                   <template v-else>
                                                        <template
                                                            v-if="amortization.amortizationPayment.length > 0 && amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentType.id === 3">
                                                            {{ pesosFormat(amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentRemaining) }}
                                                        </template>
                                                        <template v-else>
                                                            {{ pesosFormat(pagoRestanteApagar(amortization)) }}
                                                        </template>
                                                   </template>
                                                </template>
                                            </td>
                                            <!--18 Pago Total-->
                                            <td>
                                                <template v-if="isClickCalculate.anticipado && amortization.remainingPaymentA !== undefined">
                                                    {{ pesosFormat(amortization.fullpaymentA) }}
                                                </template>
                                                <template v-else>
                                                        <template
                                                            v-if="amortization.amortizationPayment.length > 0 && amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentType.id === 3">
                                                        {{ pesosFormat(amortization.amortizationPayment[amortization.amortizationPayment.length - 1].fullpaymentA) }}
                                                        </template>
                                                        <template v-else>
                                                            {{ pesosFormat(pagoTotalApagar(amortization)) }}
                                                        </template>
                                                </template>
                                            </td>
                                            <!--19 Saldo Insoluto-->
                                            <td>
                                                <template
                                                    v-if="amortization.amortizationPayment.length > 0 && amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentType.id === 3">
                                                    {{ pesosFormat(0) }}
                                                </template>
                                                <template v-else>
                                                    {{ pesosFormat(amortization.finalCapital) }}
                                                </template>
                                            </td>
                                            <!--INFORMATIVO: DETALLES DEL PAGO RESTANTE-->
                                            <!--20 Capital-->
                                            <td>
                                                <template v-if="amortization.installmentNumber !== 0">
                                                    <template v-if="isClickCalculate.anticipado && amortization.remainingPaymentA !== undefined">
                                                        {{ pesosFormat(amortization.capitalA) }}
                                                    </template>
                                                    <template 
                                                        v-if="
                                                            (isClickCalculate.normal || 
                                                            isClickCalculate.moratorio || 
                                                            amortization.amortizationPayment.length > 0 && amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentType.id === 1 || 
                                                            amortization.amortizationPayment.length > 0 && amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentType.id === 2) &&
                                                            (amortization.amortizationPayment.length > 0 && amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentRemaining === 0)
                                                        "
                                                    >
                                                        <template v-if="pagoRestanteApagarUpdate(amortization) === 0">
                                                            {{ pesosFormat(0) }}
                                                        </template>
                                                        <template v-else>
                                                            {{ pesosFormat(capitalDetail(amortization)) }}
                                                        </template>
                                                    </template>
                                                    <template v-else>
                                                        <template v-if="(amortization.capitalA === undefined) || (amortization.capitalA === null && (amortization.amortizationPayment.length > 0 && amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentType.id === 3)) || (isClickCalculate.anticipado === false && isClickCalculate.moratorio === false && isClickCalculate.normal === false)">
                                                            {{ pesosFormat(capitalDetail(amortization)) }}
                                                        </template> 
                                                    </template>
                                                    <template
                                                        v-if="
                                                            (amortization.capitalA === undefined || amortization.capitalA === null) && 
                                                            (amortization.amortizationPayment.length > 0 && amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentType.id === 3) &&
                                                            (amortization.amortizationPayment.length > 0 && amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentRemaining === 0)
                                                        "
                                                    >
                                                        {{ pesosFormat(capitalDetail(amortization)) }}
                                                    </template>

                                                    <template
                                                        v-if="
                                                            amortization.amortizationPayment.length > 0 && 
                                                            amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentType.id === 3"
                                                    >
                                                        <template
                                                            v-if="amortization.amortizationPayment.length > 0 && amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentRemaining === 0">
                                                            {{ pesosFormat(0) }}
                                                        </template>
                                                        <template v-else>
                                                            {{
                                                                pesosFormat(amortization.amortizationPayment[amortization.amortizationPayment.length
                                                                    - 1].capitalA) }}
                                                        </template>
                                                    </template>
                                                    
                                                    <!-- <template v-if="amortization.amortizationPayment.length === 0 && amortization.capitalA === undefined">
                                                        HOLA 5
                                                        {{ pesosFormat(capitalDetail(amortization)) }}
                                                    </template> -->


                                                    <!-- <template v-if="amortization.amortizationPayment.length > 0 && amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentRemaining !== 0">
                                                        HOLA 8
                                                        {{ pesosFormat(capitalDetail(amortization)) }}
                                                    </template> -->
                                                </template>
                                            </td>
                                            <!--21 Interés alias Ordinario-->
                                            <td>
                                                <template v-if="isClickCalculate.anticipado && amortization.remainingPaymentA !== undefined">
                                                    {{ pesosFormat(0) }}
                                                </template>
                                                <template v-else>
                                                    {{ pesosFormat(interesDetail(amortization)) }}
                                                </template>
                                            </td>
                                            <!--22 Intereses sin IVA-->
                                            <td>
                                                <template v-if="isClickCalculate.anticipado && amortization.remainingPaymentA !== undefined">
                                                    {{ pesosFormat(0) }}
                                                </template>
                                                <template v-else>
                                                    {{ pesosFormat(interesSNIVADetail(amortization)) }}
                                                </template>
                                            </td>
                                            <!--23 IVA-->
                                            <td>
                                                <template v-if="isClickCalculate.anticipado && amortization.remainingPaymentA !== undefined">
                                                    {{ pesosFormat(0) }}
                                                </template>
                                               <template v-else>
                                                    {{ pesosFormat(interesIVADetail(amortization)) }}
                                               </template>
                                            </td>
                                            <!--24 Mora-->
                                            <td>
                                                <template v-if="isClickCalculate.normal || isClickCalculate.moratorio">
                                                    {{ pesosFormat(moraDetailUpdate(amortization)) }}
                                                </template>
                                                <template v-else>
                                                    {{ pesosFormat(moraDetail(amortization)) }}
                                                </template>
                                            </td>
                                            <!--25 Mora Sin IVA-->
                                            <td>
                                                {{ pesosFormat(moraDetailSNIVADetail(amortization)) }}
                                            </td>
                                            <!--26 IVA-->
                                            <td>
                                                {{ pesosFormat(moraIVADetail(amortization)) }}
                                            </td>
                                            <!--27 Comisiones-->
                                            <td></td>
                                            <!--28 Comisiones Sin IVA-->
                                            <td></td>
                                            <!--29 IVA-->
                                            <td></td>
                                            <!--30 Pago Restante-->
                                            <td>
                                                <template v-if="isClickCalculate.normal || isClickCalculate.moratorio">
                                                    {{ pesosFormat(pagoRestanteApagarUpdate(amortization)) }}
                                                </template>
                                                <template v-else>
                                                    <template v-if="isClickCalculate.anticipado && amortization.remainingPaymentA !== undefined">
                                                        {{ pesosFormat(amortization.remainingPaymentA) }}
                                                    </template>
                                                   <template v-else>
                                                        <template
                                                            v-if="amortization.amortizationPayment.length > 0 && amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentType.id === 3">
                                                            {{ pesosFormat(amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentRemaining) }}
                                                        </template>
                                                        <template v-else>
                                                            {{ pesosFormat(pagoRestanteApagar(amortization)) }}
                                                        </template>
                                                   </template>
                                                </template>
                                            </td>
                                        </tr>
                                        <tr v-if="getTableData.length === 0">
                                            <td colspan="30" style="text-align: center;">
                                                {{ $getLocaleMessage('common', 'noDataFound') }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <template v-if="hasPaymentReamingBD !== 0">
                        <!--Formulario de pago-->
                        <div class="form-group mt-4">
                            <label for="paymentDate">Fecha de pago:</label>
                            <Field type="date" class="form-control" name="paymentDate" rules="required" />
                            <ErrorMessage name="paymentDate" class="input-error"></ErrorMessage>
                        </div>

                        <div class="form-group">
                            <label for="paymentTime">Hora de pago:</label>
                            <Field type="time" step="1" class="form-control" name="paymentTime" rules="required"
                                placeholder="HH:mm:ss" />
                            <ErrorMessage name="paymentTime" class="input-error" />
                        </div>

                        <div class="form-group">
                            <label for="paymentAmount">Pago:</label>
                            <Field type="number" class="form-control" name="paymentAmount" rules="required" />
                            <ErrorMessage name="paymentAmount" class="input-error"></ErrorMessage>
                        </div>

                        <div class="form-group">
                            <label for="disposition">Referencia Bancaria:</label>
                            <div class="row mt-2">
                                <Field type="select" class="form-control col-sm-4" name="bank" placeholder="Banco"
                                    rules="required" />
                                <Field type="text" class="form-control col-sm-8" name="referenceBank"
                                    placeholder="Referencia" rules="required" />
                                <ErrorMessage name="referenceBankError" class="input-error" />
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="paymentType">Tipo de pago:</label>
                            <Select :name="'paymentType'" :options="getPaymentTypeOptions()"></Select>
                        </div>
                    </template>
                </template>
            </div>
        </div>
        <div class="modal-footer justify-content-between">
            <!--data-dismiss="modal"-->
            <button type="button" class="btn btn-secondary" @click="closeModal"
                :disabled="isLoading">
                {{ $getLocaleMessage('buttons', 'cancel') }}
            </button>
            <!-- Contenedor para botones juntos -->
            <div class="d-flex gap-2" v-if="hasPaymentData && hasPaymentReamingBD !== 0">
                <PrimaryButton class="btn btn-success mr-2" :disabled="isLoading" @click.prevent="calculate">
                    Calcular
                </PrimaryButton>
                <PrimaryButton class="btn btn-primary" type="submit" :disabled="!canSave" >
                    <i v-if="isLoading" class="fa fa-spinner fa-spin"></i>
                    {{ isLoading ? 'Procesando...' : 'Guardar' }}
                </PrimaryButton>
            </div>
        </div>
    </Form>
</template>
<script setup>
import { ref, computed, watch, getCurrentInstance } from 'vue';
import { storeToRefs } from 'pinia';
import { Form, Field, ErrorMessage, useForm } from 'vee-validate';
import { useToast } from 'vue-toast-notification';
import { usePaymentsStore } from '@/pinia/payments.module';
import PrimaryButton from '@/Components/PrimaryButton.vue';
import Select from '@/Components/Selects/SelectField.vue';
import Swal from 'sweetalert2';

const $toast = useToast();

const { meta } = useForm();

// Emits
const emit = defineEmits(['closeModal', 'changeModalContent', 'paymentCreated']);

// Acceder a la instancia de la app
const app = getCurrentInstance();
const filters = app?.appContext.config.globalProperties.$filters;

// Props
const props = defineProps({
    client: {
        type: Object,
        default: () => ({}),
    },
    disposition: {
        type: Object,
        default: () => ({}),
    },
    amortizatiobPayment: {
        type: Array,
        default: () => ([])
    },
    quotation: {
        type: Object,
        default: () => ({}),
    },
});

// Store
const paymentsStore = usePaymentsStore();

const {
    getLoadingState,
    getError
} = storeToRefs(paymentsStore);
const {
    addPayment,
    clearError
} = paymentsStore;

// Refs
const enabledFormPayment = ref(false);
const formRef = ref(null);
const error = ref(null);
const readOnlyTable = ref([]) ; // solo lectura
const localTable = ref([]); // editable

//Constantes
// const isClickCalculate = ref(false);
const isClickCalculate = ref({
    normal : false,
    moratorio: false,
    anticipado : false
});
const isClicSave = ref(false);

// Computed properties
const isLoading = computed(() => getLoadingState.value);
const isFormValid = computed(() => meta.value.valid);

const getProspectusReferenceNumber = computed(() => {
    return props.client?.referenceNumber || '';
});

const getProspectFullname = computed(() => {
    if (!props.client || props.client?.creditFacility?.prospectus?.prospectusId === 0) return '';

    if (props.client?.creditFacility?.prospectus?.personTypeId === 1) {
        const gi = props.client?.creditFacility?.prospectus?.generalInformation || {};
        return `${gi.firstName || ''} ${gi.lastName || ''} ${gi.mothersMaidenName || ''}`.trim();
    } else {
        return props.client?.creditFacility?.prospectus?.generalInformation?.businessName || '';
    }
});

const getBranchOffice = computed(() => {
    return props.client?.creditFacility?.prospectus?.branchOffice?.name || '';
});

const getPersonType = computed(() => {
    return props.disposition?.prospectus?.personType.name || '';
});

const getLoanApplication = computed(() => {
    return props.disposition?.loanApplication?.referenceNumber || '';
});

const getCreditScoreReference = computed(() => {
    return props.disposition?.creditScore?.referenceNumber || '';
});

const getQuotation = computed(() => {
    return props.disposition?.loanApplication?.quotations?.referenceNumber || '';
});

const getProduct = computed(() => {
    return props.disposition?.loanApplication?.quotations?.products?.referenceNumber || '';
});

const getDisposition = computed(() => {
    return props.disposition?.referenceNumber || '';
});

const getProductType = computed(() => {
    return props.disposition?.loanApplication?.quotations?.products?.productTypes?.name || '';
});

const getProductDescription = computed(() => {
    return props.disposition?.loanApplication?.quotations?.products?.description || '';
});

const getDisburmentStatus = computed(() => {
    return props.disposition?.status?.name || '';
});

const getCreditAmount = computed(() => {
    return props.disposition?.loanApplication?.quotations?.creditAmount || '';
});

const getScore = computed(() => {
    return props.disposition?.creditScore?.score || '';
});

const hasPaymentData = computed(() => {
    return Array.isArray(props.amortizatiobPayment) && props.amortizatiobPayment.length > 0;
});

const getTableData = computed(() => {
    return localTable.value;
});

const hasSelectedAmortization = computed(() => {
    return localTable.value.length > 0;
});

const hasPaymentReamingBD = computed(() => {
    let reaming = null;
    if(props.amortizatiobPayment.length > 0){
        if(props.amortizatiobPayment[props.amortizatiobPayment.length - 1].amortizationPayment.length > 0){
            reaming =  props.amortizatiobPayment[props.amortizatiobPayment.length - 1].amortizationPayment[props.amortizatiobPayment[props.amortizatiobPayment.length - 1].amortizationPayment.length - 1].paymentRemaining;
        }
    }
    return reaming;
});

const canSave = computed(() => {
    return (
        (isClickCalculate.value.normal ||
            isClickCalculate.value.moratorio ||
            isClickCalculate.value.anticipado) &&
        !isLoading.value &&
        isFormValid.value
    );
});

//Funciones del formulario

/** ⭐ Función general para limpiar todo */
const resetAll = () => {
    // Limpiando por cambio de cliente/disposición/amortización

    // 1️⃣ Reiniciar tabla
    localTable.value = [];

    // 2️⃣ Borrar errores
    clearError();
    error.value = null;

    // 3️⃣ Resetear formulario de captura
    if (formRef.value) {
        formRef.value.resetForm();
    }
};

const changeModalContent = (modalNumber) => {
    if (!isLoading.value) {
        emit('changeModalContent', modalNumber);
    }
};

const closeModalProcess = () => {
    if (!isLoading.value) {

        // 1️⃣ Limpiar tabla de amortización seleccionada
        localTable.value = [];

        // 2️⃣ Limpiar errores
        clearError();
        error.value = null;

        // 3️⃣ Limpiar formulario si existe
        if (formRef.value) {
            formRef.value.resetForm();
        }

        // 4️⃣ Avisar al padre que cierre la modal
        emit('closeModal', true);
    }
}

const closeModal = () => {
    if (isClickCalculate.value.anticipado || isClickCalculate.value.normal || isClickCalculate.value.moratorio && !isClicSave.value) {
        const alert = Swal.mixin({
            buttonsStyling: true
        });
        alert.fire({
            title: `¿Deseas salir sin guardar los cambios?`,
            icon: 'question', showCancelButton: true,
            confirmButtonText: '<i class="fa fa-solid fa-check"></i> Si, salir',
            cancelButtonText: '<i class="fa fa-solid fa-ban"></i> Cancelar',
        }).then(res => {
            if (res.isConfirmed) {
                closeModalProcess();
            } else {
                $toast.warning('Tienes cambios sin guardar. Asegúrate de guardarlos antes de salir.');
            }
        });

        return;
    }
    
    closeModalProcess();
};

// Función para limpiar el formulario
const clearForm = () => {
    if (formRef.value) {
        formRef.value.resetForm();
    }

    clearError();
    error.value = null;
};

// Exponer clearForm
defineExpose({
    clearForm
});

// Funciones auxiliares

/**
 * Formateo de moneda
 * @param value 
 */
const pesosFormat = (value) => {
    return filters.formatNumber(value);
};

/**
 * Función para formatear la fecha actual
 * @param year 
 * @param month 
 * @param day 
 */
const getDateActul = (year = null, month = null, day = null) => {
    // 2026, 1, 22
    let fechaActual = (year === null && month === null && day === null) ? new Date() : new Date(year, month, day);
    const dateActualOnly = new Date(
        fechaActual.getFullYear(),
        fechaActual.getMonth(),
        fechaActual.getDate()
    );
    return dateActualOnly;
}

/**
 * Función para formatear la fecha de vencimiento
 * @param value 
 */
const getDateVencido = (value) => {
    let vencimiento = new Date(value.dueDate);
    const dateVencimientoOnly = new Date(
        vencimiento.getFullYear(),
        vencimiento.getMonth(),
        vencimiento.getDate()
    );
    return dateVencimientoOnly;
}

/**
 * Función para calcular los días transcurridos
 * @param dateActualOnly 
 * @param dateVencimientoOnly 
 */
const getDiasTranscurridos = (dateActualOnly , dateVencimientoOnly) => {
    // Milisegundos en un día
    const MS_PER_DAY = 1000 * 60 * 60 * 24;
    // Dias transcurridos: Diferencia en días
    let daysElapsed = Math.floor(Math.abs(dateActualOnly - dateVencimientoOnly) / MS_PER_DAY);
    return daysElapsed;
}

/**
 * Función para validar mes y año actual vs mes y año de vencimiento
 * @param fechaActual 
 * @param fechaVencimiento 
 */
const validarMesAnterior = (fechaActual, fechaVencimiento) => {
    const yearActual = fechaActual.getFullYear();
    const monthActual = fechaActual.getMonth();
    const yearVenc = fechaVencimiento.getFullYear();
    const monthVenc = fechaVencimiento.getMonth();

    if (
        yearActual > yearVenc ||
        (yearActual === yearVenc && monthActual >= monthVenc)
    ) {
        return false;
    } else {
        return true;
    }
}

/**
 * Función para sacar la mora acomulada
 * @param value 
 */
const morasAcomuladas = (value) => {
    return value.amortizationPayment.reduce((total, item) => total + item.latePayment, 0);
}

/**
 * Función para calcular la tasa diaria sin IVA
 */
const getTasaDiariaSNIva = () => {
    let dailyDelinquencyRate = (props.disposition?.loanApplication?.quotations?.annualRate * 2) / 360;
    return dailyDelinquencyRate;
}

/**
 * Función para sacar 
 * @param pagoRestante 
 * @param dailyDelinquencyRate 
 * @param daysElapsed 
 */
const getLatePaymentPartial = (pagoRestante, dailyDelinquencyRate, daysElapsed) => {
    let calculationLatePaymentPartial = pagoRestante * dailyDelinquencyRate * daysElapsed * 1.16;
    return calculationLatePaymentPartial;
}
 
/**
 * Función para capturar los valores actuales de la tabla
 */
const saveTableDataBeforeCalculate = () => {
    if (!Array.isArray(getTableData.value)) return;

    // Sacar una copia de la tabla anterior
    // Copia profunda de la tabla calculada
    readOnlyTable.value = getTableData.value.map((amortization) => ({ // Nota: Solo coloque algunos valores los que me interesar recuperar en el guardado
        installmentNumber: amortization.installmentNumber,
        dueDate: amortization.dueDate,
        initialCapital: amortization.initialCapital,
        interest: amortization.interest,
        tax: amortization.tax,
        commissions: amortization.commissions,
        taxes: amortization.taxes,
        moraGenerado: totalLatePaymentGeneration(amortization),
        ivaGenerado: taxGeneratedValueAdded(amortization),
        capitalToPay: amortization.capital,
        interesPagar: interesApagar(amortization),
        moraPagar: totalLatePaymentApagar(amortization),
        pagoRealizado: calPagoRealizado(amortization),
        pagoTotal: pagoTotalApagar(amortization),
        interesDetail: interesDetail(amortization),
        moraDetail: moraDetail(amortization)
    }));
}

/**
 * Función auxiliar para identificar que capital tomar para el calculo de moras generados e informe detallado
 * @param value 
 */
const auxCapital = (value) => {
    const isFirstPayment = value.amortizationPayment.length === 1;
    const paymentAmountData = value.amortizationPayment[value.amortizationPayment.length - 1].paymentAmount;
    let interesIva = value.amortizationPayment[value.amortizationPayment.length - 1].paymentInterest;
    let latePaymentData = value.amortizationPayment[value.amortizationPayment.length - 1].latePayment;
    let remanenteData = value.amortizationPayment[value.amortizationPayment.length - 1].paymentRemaining;
    let mora = 0;
    let moraA = 0;
    let capitalResult = 0;

    if(isFirstPayment) {
        capitalResult = paymentAmountData <= interesIva ? value.capital : (interesIva + value.capital - paymentAmountData);
        return capitalResult;
    }

    // capitalResult = paymentAmountData - mora anterior - interes remanente anterior  ? 0 : (interes remanente anterior + mora remanente anterior + capital remanente anterior + mora anterior - pago anterior - mora remanente actual - interes remanente actual)
    capitalResult = (paymentAmountData - latePaymentData - interesIva) > remanenteData ? 0 : (interesIva + mora + remanenteData + interesIva + latePaymentData - paymentAmountData - moraA);
    return capitalResult;
}

// Datos calculados

/**
 * <!--16 Pago Realizado AQUI APLICA DIFERENTE-->
 * Pago total restante
 * Suma de todos los pagos que se guardaron para cubrir pago total
 * La suma total de la columna de PaymentAmount de la BD de un registro(QuotationId) especifico.
 * @param value 
 */
const totalPaymentRemaining = (value) => {
    return value.amortizationPayment.reduce((total, item) => total + item.paymentAmount, 0);
}

/**
 * Mora Generado <!--10 Mora-->
 * Generación total de pagos atrasados
 * @param value Amortización (quotation)
 */
const totalLatePaymentGeneration = (value) => {
    let pagoMensual = Math.abs(value.installmentWithVat - totalPaymentRemaining(value));
    if(pagoMensual <= 0){
        // Pago cubierto
        return Math.abs(value.installmentWithVat - totalPaymentRemaining(value));
    } else {
        // Pagos pendientes        
        // Fecha actual
        const dateActualOnly = getDateActul();
        // Fecha de vencimiento
        const dateVencimientoOnly = getDateVencido(value);
        // Paso #1 Sacar los dias transcurridos del día de vencimiento
        // Dias transcurridos: Diferencia en días
        let daysElapsed = getDiasTranscurridos(dateActualOnly, dateVencimientoOnly);

        // validar si ya paso muchos dias de pago
        if(dateActualOnly >= dateVencimientoOnly){
            // Generar Mora : Pago pendiente con MORA
            // Tasa Diaria sin IVA
            let dailyDelinquencyRate = getTasaDiariaSNIva();
            // Revisar si ya hay un pago existen por flujo a paguitos
            if(value.amortizationPayment.length > 0){
                // Flujo de mora con pagos registrados
                let dateLastPaymentData = value.amortizationPayment[value.amortizationPayment.length - 1].paymentDate;
                let [year, month, day] = dateLastPaymentData.split('-').map(Number);
                let dateLastPayment = getDateActul(year, month - 1, day);
                // daysElapsed = getDiasTranscurridos(dateActualOnly, dateLastPayment);
                // Sacar todos las moras anteriores con su pago mensual
                // Sacar Mora generada del pago acomulado
                let remanenteData = value.amortizationPayment[value.amortizationPayment.length - 1].paymentRemaining; //Este dato se guarda en BD en PaymentRemaining *Notaa verificar si no va la suma total de todos los paymentReaming totalPaymentRemainingData testear
                
                // Validar si tiene un pago (el utlimo pago se hizo en tiempo y forma)
                if(dateLastPayment <= dateVencimientoOnly) {
                    // En este caso tomamos la capital origen anterior
                    // Verificar si es el primer pago (verificar si esta de mas esta validación o es correcta)
                    let isFirstPayment = value.amortizationPayment.length;

                    if(isFirstPayment === 1){
                        // var calculationLatePaymente = (value.capital * dailyDelinquencyRate * daysElapsed) * 1.16;
                        var calculationLatePaymente = (auxCapital(value) * dailyDelinquencyRate * daysElapsed) * 1.16;  
                        var calculationLatePaymentResult = calculationLatePaymente / 1.16;
                        return calculationLatePaymentResult;
                    }
                }

                // sobre escribir remanenteData
                let interest = value.amortizationPayment[value.amortizationPayment.length - 1].paymentInterest;
                if(totalPaymentRemaining(value) <= interest){
                    remanenteData = value.capital;
                }

                // sobre-escribir la fecha transcurrida del utlimo pago a la fecha actual
                daysElapsed = getDiasTranscurridos(dateActualOnly, dateLastPayment);
                var calculationLatePayment = (remanenteData * dailyDelinquencyRate * daysElapsed) * 1.16;
                // Suma todas las moras acomuladas
                let morasAcomuladasData = morasAcomuladas(value);
                var result = (morasAcomuladasData + calculationLatePayment) / 1.16;
                return result;                
            }

            // Flujo de mora sin pagos registrados
            // Va directo a Capital
            var calculationLatePayment = (value.capital * dailyDelinquencyRate * daysElapsed) * 1.16;
            // Nota: No aplica la suma de moras acomuladas porque no se ha guardado nigun registro de pago lo cual va directo calculationLatePayment
            var result = calculationLatePayment / 1.16;
            return result;
        } else {
            // No Generar Mora porque esta en tiempo y forma de hacer su pago: Un pago pendiente SIN Mora
            return 0;
        }
    }
}

/**
 * IVA Generado
 *  <!--11 IVA-->
 * @param value 
 */
const taxGeneratedValueAdded = (value) =>{
    return totalLatePaymentGeneration(value) * 0.16;
}

/**
 * <!--12 Capital-->
 * @param value 
 */
const calCapitalPA = (value) => {
    //amortization.amortizationPayment[amortization.amortizationPayment.length - 1].capitalPA
    const pagoActual =  Number(formRef.value?.values?.paymentAmount);
    if(value.amortizationPayment.length > 0 && value.amortizationPayment[value.amortizationPayment.length - 1].capitalA !== null){
        return Math.abs(value.amortizationPayment[value.amortizationPayment.length - 1].capitalA - pagoActual);
    }

    return value.capital;
}

/**
 * Ineteres a pagar = ineres generado + iva generado
 * <!--13 Interés-->
 * @param value
 */
const interesApagar = (value) => {
    let quotationInteres = value.interest;
    let quotationIva = value.tax;
    let result = quotationInteres + quotationIva;
    return result;
}

/**
 * <!--15 Mora-->
 * @param value
 */
const totalLatePaymentApagar = (value) => {
    return totalLatePaymentGeneration(value) + taxGeneratedValueAdded(value);
}

// <!-- 16 -->
const calPagoRealizado = (value) => {
    let valuePayment = Number(formRef.value?.values?.paymentAmount ?? 0);

    if(value.amortizationPayment?.length ?? 0 > 0){
        // Hay pagos registrado
        return isClickCalculate.value.normal || isClickCalculate.value.moratorio ? totalPaymentRemaining(value) + valuePayment : totalPaymentRemaining(value); 
    }

    // No existe pagos registrados
    return isClickCalculate.value.normal || isClickCalculate.value.moratorio ? valuePayment : value?.paymentMadeA ?? 0;
}

/**
 * <!--17 Pago Restante-->
 * @param value
 */
const pagoRestanteApagar = (value) => {
    let capital = value.capital;
    let mensual = Number(value.installmentWithVat); //.toFixed(2);
    let moraApagar = totalLatePaymentApagar(value);
    let totalPagado = totalPaymentRemaining(value);

    if(totalPagado === mensual){
        // Pago Mensual completado
        return Math.abs(mensual - totalPagado);
    }

    if (moraApagar <= 0) {
        // Pago Mensual sin Cargo

        if(value.amortizationPayment.length > 0){ // Existen pagos anteriores
            const pagoRegistrado = value.amortizationPayment[value.amortizationPayment.length - 1].paymentAmount;
            const calRestante = Math.abs(mensual - pagoRegistrado);
            return calRestante;
        }

        return mensual;
    }

    // Pago Mensual con Cargo
    let tasaDiariaSNIVA = getTasaDiariaSNIva();
    const dateActualOnly = getDateActul();
    const dateVencimientoOnly = getDateVencido(value);
    let daysElapsed = getDiasTranscurridos(dateActualOnly, dateVencimientoOnly);

    // Flujo con pagos registrados
    if(value.amortizationPayment.length > 0){
        // Suma del ultimo remanente registrado + la ultima mora + la suma total de pago o la suma del monto capturado de pago ultimo
        let ultimoRemanente = value.amortizationPayment[value.amortizationPayment.length - 1].paymentRemaining;
        let tasaDiariaSNIVA = getTasaDiariaSNIva();
        // Sobre escribir la fecha transcurrida del utlimo pago a la fecha actual
        let dateLastPaymentData = value.amortizationPayment[value.amortizationPayment.length - 1].paymentDate;
        const [year, month, day] = dateLastPaymentData.split('-').map(Number);
        let dateLastPayment = getDateActul(year, month - 1, day);
        // Sobre escribir el tiempo transcurrido de acuerdo al ultimo pago registrado ya no de la fecha del vencimiento origen
        daysElapsed = getDiasTranscurridos(dateActualOnly, dateLastPayment);
        
        if(dateLastPayment <= dateVencimientoOnly){
            let result = ultimoRemanente + moraApagar;
            return result;
        }
        
        let pagoAnterior = value.amortizationPayment[value.amortizationPayment.length - 1].paymentAmount;
        let moraAnterior = value.amortizationPayment[value.amortizationPayment.length - 1].latePayment;

        if(pagoAnterior >= moraAnterior){
            // La mora anterior fue saldada
            let moraActual = moraDetail(value);
            let calPagoRestante = ultimoRemanente + moraActual;
            return calPagoRestante;
        }

        let generarMora = (ultimoRemanente * tasaDiariaSNIVA * daysElapsed) * 1.16;
        let result = ultimoRemanente + generarMora;
        return result;
    }

    // Flujo sin pagos registrados
    let calPartial = getLatePaymentPartial(capital, tasaDiariaSNIVA, daysElapsed);
    let result = mensual + calPartial - totalPagado;
    return result;
}

/**
 * Distinguir el valor del pago mensual entre pagos normales, moratorios y anticipados
 * @param value 
 */
const getMensual = (value) => {
  const last = value.amortizationPayment.at(-1);
  return last?.paymentTypeId === 3
    ? last.paymentRemaining
    : pagoRestanteApagar(value);
};

/**
 * <!--17 Pago Restante-->
 * Ocupado para cual damos click al boton calcular
 * @param value 
 */
const pagoRestanteApagarUpdate = (value) => {
    let mensual = getMensual(value);
    let valuePayment = Number(formRef.value?.values?.paymentAmount ?? 0);

    if(value.amortizationPayment?.length ?? 0 > 0){
        // Hay pagos registrados
        // Revisar mora
        let result = Math.abs(mensual - valuePayment);
        return result;
    }

    // No existe pagos registrados
    // Se ha cubierto la entrada capturada del pago con respecto a lo que se debe ¿?
    if(valuePayment >= mensual){
        
        if(valuePayment === mensual){
            // Pago completado
            return Math.abs(valuePayment - mensual);
        }

        // Pago con abono
        // Si sucede este caso hay que afectar a otra fila para realizar un abono (**Pendiente trabajar mas adelante)
        return Math.abs(valuePayment - mensual);
    }

    // Pago incompleto
    let result = Math.abs(valuePayment - mensual);
    return result;
}

/**
 * <!--18 Pago Total-->
 * @param value
 */
const pagoTotalApagar = (value) => {
    let capital = value.capital;
    let mensual = value.installmentWithVat;
    let moraApagar = totalLatePaymentApagar(value);
    let totalPagado = totalPaymentRemaining(value);
    if (moraApagar <= 0) {
        // Pago Mensual sin Cargo
        return mensual;
    }

    // Pago Mensual con Cargo
    let tasaDiariaSNIVA = getTasaDiariaSNIva(); 
    const dateActualOnly = getDateActul();
    const dateVencimientoOnly = getDateVencido(value);
    let daysElapsed = getDiasTranscurridos(dateActualOnly, dateVencimientoOnly);
   
    // Flujo con pagos registrados
    if(value.amortizationPayment.length > 0){
        let pagoRemanente = value.amortizationPayment[value.amortizationPayment.length - 1].paymentRemaining;
        let tasaDiariaSNIVA = getTasaDiariaSNIva();
        let dateLastPaymentData = value.amortizationPayment[value.amortizationPayment.length - 1].paymentDate;
        const [year, month, day] = dateLastPaymentData.split('-').map(Number);
        let dateLastPayment = getDateActul(year, month - 1, day);
        daysElapsed = getDiasTranscurridos(dateActualOnly, dateLastPayment);

        if(dateLastPayment <= dateVencimientoOnly){
            let pagoRestante = pagoRestanteApagar(value);
            let result = totalPagado + pagoRestante;
            return result;
        }

        let pagoAnterior = value.amortizationPayment[value.amortizationPayment.length - 1].paymentAmount;
        let moraAnterior = value.amortizationPayment[value.amortizationPayment.length - 1].latePayment;
        let interesAnterior = value.amortizationPayment[value.amortizationPayment.length - 1].paymentInterest;

        let calCapitalOp = pagoRemanente;
        if(pagoAnterior < interesAnterior){
            calCapitalOp = value.capital;
        }

        let generarMoraActual = (calCapitalOp * tasaDiariaSNIVA * daysElapsed) * 1.16;
        let pagoRemanenteMora = pagoRemanente + generarMoraActual;
        let result = totalPagado + pagoRemanenteMora;
        return result;
    }

    // Flujo sin pagos registrados
    let calPartial = getLatePaymentPartial(capital, tasaDiariaSNIVA, daysElapsed);
    let result = mensual + calPartial - totalPagado;
    return result;
}

/**
 * <!--20 Capital-->
 * @param value
 */
const capitalDetail = (value) => {
    const pagoRestanteValue = isClickCalculate.value.normal || isClickCalculate.value.moratorio ? pagoRestanteApagarUpdate(value) : pagoRestanteApagar(value);
    const pagoMoraValue = isClickCalculate.value.normal || isClickCalculate.value.moratorio ? moraDetailUpdate(value) : moraDetail(value);
    const existenPagos = value.amortizationPayment.length > 0 ? true : isClickCalculate.value ?? false;

    if (existenPagos) {
        let calCapital = 0;

        if (pagoRestanteValue === 0) {
            // Capital queda en 0 tambien (Capital Pagado) Capital = 0
            return calCapital;
        }

        // Saca (Saldo capital)  Capital = PagoRestante - Interes - Mora
        calCapital = pagoRestanteValue - interesDetail(value) - pagoMoraValue;
        return calCapital;        
    }

    // Origen (Capital Inicial) Capital = Mensualidad - Intres - Iva
    return value.capital;
}

/**
 * <!--21 Interés alias Ordinario-->
 * @param value
 */
const interesDetail = (value) => {
    const moraAnterior = 
        value.amortizationPayment.length > 0 ?
            isClickCalculate.value.normal || isClickCalculate.value.moratorio ? readOnlyTable.value[readOnlyTable.value.length - 1].moraDetail : value.amortizationPayment[value.amortizationPayment.length - 1].latePayment 
        :
            isClickCalculate.value.normal || isClickCalculate.value.moratorio ? readOnlyTable.value[readOnlyTable.value.length - 1].moraDetail : 0
        ; // <!-- este cambio resolvio el Escenario 7
    const moraActual = moraDetail(value);
    const ordinarioAnterior = 
        value.amortizationPayment.length > 0 ? 
           isClickCalculate.value.normal || isClickCalculate.value.moratorio ? readOnlyTable.value[readOnlyTable.value.length - 1].interesDetail : value.amortizationPayment[value.amortizationPayment.length - 1].paymentInterest 
        :  
            isClickCalculate.value.normal || isClickCalculate.value.moratorio ? readOnlyTable.value[readOnlyTable.value.length - 1].interesDetail : 0;       
    const ordinarioActual = interesApagar(value);
    const pagoAnterior = 
        value.amortizationPayment.length > 0 ?
            isClickCalculate.value.normal || isClickCalculate.value.moratorio ? Number(formRef.value?.values?.paymentAmount) : value.amortizationPayment[value.amortizationPayment.length - 1].paymentAmount 
        :
            isClickCalculate.value.normal || isClickCalculate.value.moratorio ? Number(formRef.value?.values?.paymentAmount) : 0
        ; // <!-- este cambio resolvio el Escenario 7
    const existePrimerPago = value.amortizationPayment.length > 0 ? true : (isClickCalculate.value.normal || isClickCalculate.value.moratorio) ?? false;
    let fechaAnteriorBD = value.amortizationPayment.length > 0 ? value.amortizationPayment[value.amortizationPayment.length - 1].paymentDate : null;
    let fechaAnterior = null;
    if(fechaAnteriorBD !== null){
        let [year, month, day] = fechaAnteriorBD.split('-').map(Number);
        fechaAnterior = getDateActul(year, month - 1, day);
    }
    const fechaActual = getDateActul();
    const fechaDeVencimiento = getDateVencido(value);
    let saldo = Math.abs(pagoAnterior - moraAnterior);

    // El interes siempre se trata de cubrir desde el primer pago
    if (existePrimerPago) {        
        // Primero preguntar si anteriormente existio una mora por cubrir antes del pago del interes
        if (moraAnterior > 0) {
            // Si existio una mora por cubrir anteriormente
            // Revisar la mora anterior se termino de saldar
            if(pagoAnterior > moraAnterior){ // <!-- Escenario 25
                // Si el resultado es mayor quiere decir que si cubrio la mora anterior
                // Verificar si el saldo que quedo ayuda a cubrir el interes anterior
                if(saldo > ordinarioAnterior){
                    // Si es mayor se cubrio el interes anterior
                    return 0;
                }
                // Si no es mayor hay que mostrar que alcanzo cubrir del interes anterior
                return Math.abs(saldo - ordinarioAnterior);
            }

            // Si el resultado es menor quiere decir que no se cubrio la mora anterior
            if(ordinarioAnterior === 0){ // <!-- Escenario 9
                return ordinarioAnterior;
            }

            if(saldo > ordinarioActual){ 
                return 0;
            }

            if(moraActual !== 0){ // <--- Escenario 23
                return ordinarioActual;
            }
            
            return Math.abs(saldo - ordinarioActual);
        }

        // No existio nigun mora por cubrir anteriormente
        // Validamos si con el pago ingresado este se pudo cubrir en su totalidad o si no se alcanzo cubrir        
        // Existe algun pago para ver si se cubrio el interes
        if(pagoAnterior > 0){
            if(pagoAnterior > ordinarioAnterior){
                // Si el pago anterior es mayor que el interes anterior quiere decir que se cubrio en totalidad el interes
                return 0;
            }
            // Si el pago anterior no es mayor que el interes anterior quiere decir que no se cubrio en totalidad el interes y quedo sobrante por cubrir de interes
            return Math.abs(pagoAnterior - ordinarioAnterior);
        }
    }
    // Si aun no existe algun registro de pago entonces el pago oridinario esta intacto
    return ordinarioActual;
}

/**
 * <!--22 Intereses sin IVA-->
 * @param value
 */
const interesSNIVADetail = (value) => {
    return interesDetail(value) / 1.16;
}

/**
 * <!--23 IVA-->
 * @param value
 */
const interesIVADetail = (value) => {
    return interesSNIVADetail(value) * 0.16;
}

/**
 * Procedimiento para generar la Mora
 * <!--24 Mora-->
 * @param value
 */
const moraDetail = (value) => {
    const pagoAnterior = value.amortizationPayment.length > 0 ? value.amortizationPayment[value.amortizationPayment.length - 1].paymentAmount : 0;
    const moraAnterior = value.amortizationPayment.length > 0 ? value.amortizationPayment[value.amortizationPayment.length - 1].latePayment : 0;
    const interesAnterior = value.amortizationPayment.length > 0 ? value.amortizationPayment[value.amortizationPayment.length - 1].paymentInterest : 0;
    const remanenteAnterior = value.amortizationPayment.length > 0 ? value.amortizationPayment[value.amortizationPayment.length - 1].paymentRemaining : 0;
    let fechaAnteriorBD = value.amortizationPayment.length > 0 ? value.amortizationPayment[value.amortizationPayment.length - 1].paymentDate : null;
    let fechaAnterior = null;
    if(fechaAnteriorBD !== null){
        let [year, month, day] = fechaAnteriorBD.split('-').map(Number);
        fechaAnterior = getDateActul(year, month - 1, day);
    }
    const fechaDeVencimiento = getDateVencido(value);
    const fechaActual = getDateActul();
    const existenPagos= value.amortizationPayment.length > 0 ? true : false;
    const capital = value.capital;
    let tasaDiariaSNIVA = getTasaDiariaSNIva();

    if(existenPagos){
        // Existen pagos Anteriores
        // Dame la fecha del ultimo pago anterior
        if(fechaAnterior !== null){
            // Validar si no ocupare llevar esta validación aqui if (fechaActual <= fechaDeVencimiento) si es true entra a lo programado si es false retornaria 0
            // Resulto que estaba en lo correcto si me falta agregar esta validación
            if(fechaActual <= fechaDeVencimiento) { // <!-- Cubre el Escenario 30 Pago Normal (Se trabaja sin verificar el tipo por la razon de que cuando consultamos por primera vez la tabla ahi no contamos con la selección de tipo entonces por eso se opto por una solución generica)
                // No debemos generar Mora
                return 0;
            }

            // Verificar los dias transcurridos de la fecha del pago anterior
            // let diasTranscurridos = getDiasTranscurridos(fechaActual, fechaAnterior);
            let diasTranscurridos = fechaAnterior <= fechaDeVencimiento ? getDiasTranscurridos(fechaActual, fechaDeVencimiento) : getDiasTranscurridos(fechaActual, fechaAnterior);
            // Sacar capital
            let calCR = capital < remanenteAnterior ? capital : remanenteAnterior;
            
            if(pagoAnterior < moraAnterior){ // <!-- Escenario 23
                // Verificamos si podemos ocupar la formula de la generación de la Mora si resulta que el pago es mayor si no toca mostrar el sobrante pendiente por pagar
                return Math.abs(pagoAnterior - moraAnterior);
            }

            // Generar Mora actual
            // =(+AE20*$S$8*AN20*AQ20)*1.16
            // Calcular mora (Falta anexar la multiplicación por el 100%)
            let resultMora = (calCR * tasaDiariaSNIVA * diasTranscurridos) * 1.16;
            return resultMora;
        }
    }

    // Ocupamos Generar Mora
    if (fechaActual > fechaDeVencimiento) {
        let diasTranscurridosSinPagos = getDiasTranscurridos(fechaActual, fechaDeVencimiento);
        if (diasTranscurridosSinPagos > 0) {
            // Generar Mora actual
            // =(+AE20*$S$8*AN20*AQ20)*1.16
            // Calcular mora (Falta anexar la multiplicación por el 100%)
            let resultMoraSNPagos = (capital * tasaDiariaSNIVA * diasTranscurridosSinPagos) * 1.16;
            return resultMoraSNPagos;
        }
    }   

    // No existe mora a generar
    return 0;
}

/**
 * Procedimiento para generar la Mora
 * <!--24 Mora--> Esta lo coupamos cuando damos clic al boton de calcular
 * @param value 
 */
const moraDetailUpdate = (value) => {
    const pagoActual =  Number(formRef.value?.values?.paymentAmount);
    const pagoAnterior = 
    value.amortizationPayment.length > 0 ? 
            isClickCalculate.value.normal || isClickCalculate.value.moratorio ? pagoActual :  value.amortizationPayment[value.amortizationPayment.length - 1].paymentAmount 
        : 
            0
    ;
    const moraAnterior = 
        value.amortizationPayment.length > 0 ? 
            isClickCalculate.value.normal || isClickCalculate.value.moratorio ? readOnlyTable.value[readOnlyTable.value.length - 1].moraDetail : value.amortizationPayment[value.amortizationPayment.length - 1].latePayment 
        : 
            isClickCalculate.value.normal || isClickCalculate.value.moratorio ? readOnlyTable.value[readOnlyTable.value.length - 1].moraDetail : 0 // <!-- Creio lo ocupe para el Escenario 23 ¿?
        ;
    const interesAnterior = value.amortizationPayment.length > 0 ? value.amortizationPayment[value.amortizationPayment.length - 1].paymentInterest : 0;
    const remanenteAnterior = value.amortizationPayment.length > 0 ? value.amortizationPayment[value.amortizationPayment.length - 1].paymentRemaining : 0;
    let fechaAnteriorBD = value.amortizationPayment.length > 0 ? value.amortizationPayment[value.amortizationPayment.length - 1].paymentDate : null;
    let fechaAnterior = null;
    if(fechaAnteriorBD !== null){
        let [year, month, day] = fechaAnteriorBD.split('-').map(Number);
        fechaAnterior = getDateActul(year, month - 1, day);
    }
    const fechaDeVencimiento = getDateVencido(value);
    const fechaActual = getDateActul();
    const existenPagos= value.amortizationPayment.length > 0 ? true : false;
    const capital = value.capital;
    let tasaDiariaSNIVA = getTasaDiariaSNIva();

    if(existenPagos){
        // Existen pagos Anteriores

        // Flujo por pagos anticipados anteriores registrados para ese registro actual
        //value.amortizationPayment[value.amortizationPayment.length - 1].paymentAmount
        // Comprobando si dentro de sus pagos anteriores existe algun pago de tipo anticipado
        if(value.amortizationPayment.length > 0 && value.amortizationPayment.filter(p => p.paymentTypeId === 3).length > 0){ 
            // Si si existe entonces la mora muere o se muestra el valor de la mora del ultimo registro de tipo anticipado
            return value.amortizationPayment.filter(p => p.paymentTypeId === 3)[value.amortizationPayment.filter(p => p.paymentTypeId === 3).length - 1].latePayment;
            // return 0;
        }

        // Dame la fecha del ultimo pago anterior
        if(fechaAnterior !== null){
            // Validar si no ocupare llevar esta validación aqui if (fechaActual > fechaDeVencimiento) si es true entra a lo programado si es false retornaria 0
            if (fechaActual > fechaDeVencimiento) {
            // Verificar los dias transcurridos de la fecha del pago anterior
            let diasTranscurridos = getDiasTranscurridos(fechaActual, fechaAnterior);
            // Sacar capital
            let calCR = capital < remanenteAnterior ? capital : remanenteAnterior;
            
            if(pagoAnterior < moraAnterior){ // <!-- Escenario 23
                // Verificamos si podemos ocupar la formula de la generación de la Mora si resulta que el pago es mayor si no toca mostrar el sobrante pendiente por pagar
                return Math.abs(pagoAnterior - moraAnterior);
            }

            if(moraAnterior !== 0 && pagoAnterior > moraAnterior){ // <!-- Escenario 7
                return 0;
            }

            // Generar Mora actual
            // =(+AE20*$S$8*AN20*AQ20)*1.16
            // Calcular mora (Falta anexar la multiplicación por el 100%)
            let resultMora = (calCR * tasaDiariaSNIVA * diasTranscurridos) * 1.16;
            return resultMora;
            }
        }
    }

    // Ocupamos Generar Mora
    if (fechaActual > fechaDeVencimiento) {
        let diasTranscurridosSinPagos = getDiasTranscurridos(fechaActual, fechaDeVencimiento);
        if (diasTranscurridosSinPagos > 0) {
            // Aqui podria ser pagoActual o pagoAnterior
            if(pagoActual > moraAnterior) { // <!-- Escenario 15
                // La mora ha sido salda en su totalidad
                return 0;
            }

            if(pagoActual < moraAnterior) {
                // No se pude subrir la totalidad del pago de la mora dame la diferencia de lo que me falta pagar de mora <!-- Creo lo ocuper para el Escenario 23 ¿?
                let difMora = Math.abs(moraAnterior - pagoActual);
                return difMora;
            }


            // Generar Mora actual
            // =(+AE20*$S$8*AN20*AQ20)*1.16
            // Calcular mora (Falta anexar la multiplicación por el 100%)
            let resultMoraSNPagos = (capital * tasaDiariaSNIVA * diasTranscurridosSinPagos) * 1.16;
            return resultMoraSNPagos;
        }
    }   

    // No existe mora a generar
    return 0;
}

/**
 * <!--25 Mora Sin IVA-->
 * @param value
 */
const moraDetailSNIVADetail = (value) => {
    let moraDetailValue = isClickCalculate.value.normal || isClickCalculate.value.moratorio ? moraDetailUpdate(value) : moraDetail(value);
    return moraDetailValue / 1.16;
}

/**
 * <!--26 IVA-->
 * @param value
 */
const moraIVADetail = (value) => {
    return moraDetailSNIVADetail(value) * 0.16;
}

// Methods
const getPaymentTypeOptions = () => {
    // **Pendiente tomar los datos del endpoint del catalogo de tipo de pago
    return [
        { value: 1, label: 'Pago Normal' },
        { value: 2, label: 'Pago Moratorio' },
        { value: 3, label: 'Pago Anticipado' },
        { value: 4, label: 'Pago Especial' }
    ];
}

const calculate = () => {
    // Sacar una copia de la tabla anterior
    saveTableDataBeforeCalculate(); // guardamos snapshot

    const paymentType = Number(formRef.value?.values?.paymentType);
    isClickCalculate.value.normal = false; // REVISAR SI ESTO NO AFECTO
    isClickCalculate.value.moratorio = false;
    isClickCalculate.value.anticipado = false;

    if (!isFormValid.value) {
        error.value = 'Por favor seleccione un prospecto, disposición válidos y completa la captura de pago';
        return;
    }

    if (!paymentType) {
        error.value = "Debe seleccionar un tipo de pago.";
        return;
    }

    if(paymentType === 1){
        isClickCalculate.value.normal = true;
        $toast.info("Calculos aplicados");
    }

    if(paymentType === 2){
        isClickCalculate.value.moratorio = true;
        $toast.info("Calculos aplicados");
    }

    if(paymentType === 3){
        isClickCalculate.value.anticipado = true;
        return advancePayment();
    }

    // if (onAbono()) {
    //     return;
    // }

}

const onAbono = () => { // <!-- Escenario 33 Cargo de abono a su siguiente linea de pago por automatico
    const paymentAmount = Number(formRef.value?.values?.paymentAmount ?? 0);

    if (localTable.value.length === 0) return false;

    // Última fila visible en la tabla
    const lastRow = localTable.value[localTable.value.length - 1];

    // Lo que realmente se debe pagar en esa fila
    // const paymentRemaining = pagoRestanteApagarUpdate(lastRow);

    const paymentRemaining = pagoRestanteApagar(lastRow);

    // 🔥 Si el pago es MAYOR al restante → hay abono
    // console.log("REMANENTE A PAGAR: ", paymentAmount, paymentRemaining) // 20381.828909399977
    // Falta agregar validación .toFixed(2)
    if (paymentAmount > paymentRemaining.toFixed(2) && paymentRemaining.toFixed(2) !== 0) {

        const excedente = paymentAmount - paymentRemaining;

        const numeroDePago = lastRow.installmentNumber;

        // Traer siguiente fila real desde quotation
        const nextRow = props.quotation?.loanAmortization?.[numeroDePago + 1];

        if (!nextRow) return false;

        // Clon profundo para no romper reactividad
        const newRow = JSON.parse(JSON.stringify(nextRow));

        // 👉 Opcional: puedes guardar el excedente si lo quieres usar luego
        newRow.abonoAplicado = excedente;

        // Insertar nueva fila en la tabla reactiva
        localTable.value.push(newRow);

        // console.log("Abono detectado. Excedente:", excedente);

        return true;
    }

    return false;
}

/**
 * Flujo de pago Anticipado
 */
const advancePayment = () => {
    const registroActual = props.amortizatiobPayment;
    // Fecha actual
    const dateActualOnly = getDateActul();
    // Fecha de vencimiento
    const dateVencimientoOnly = getDateVencido(registroActual[registroActual.length - 1]);
    const ruleZero = validarMesAnterior(dateActualOnly, dateVencimientoOnly);
    if (ruleZero) {
        const primerPagoDelMes = registroActual[registroActual.length - 1].amortizationPayment.length === 0;
        if (primerPagoDelMes) {
            //  SI ES EL PRIMER PAGO: EFECTUAR PAGO ANTICIPADO PRIMER FILTRO:

            if (readOnlyTable.value[readOnlyTable.value.length - 1].moraDetail > 0) {
                $toast.warning("No se puede efectuar este tipo de pago ya que se requiere cubrir en totalidad el pago del mes");
                return;
            }

            const mesesCumplidosRN = true; // BANDERA QUE ME AYUDARA PARA COLOCAR LAS REGLAS DE NEGOCIOS *PENDIETE
            if (mesesCumplidosRN) {
                // EFECTUAR PAGO ANTICIPADO SEGUNDO FILTRO: Para las reglas de negocio de los meses si cumple
                const indexActual = registroActual[registroActual.length - 1].installmentNumber;
                const registroAnterior = props.quotation?.loanAmortization?.find(x => x.installmentNumber === (indexActual - 1));
                if (pesosFormat(pagoRestanteApagar(registroAnterior)) === pesosFormat(0)) {

                    let montoPagado = formRef.value?.values?.paymentAmount;
                    const vacio = 0;

                    // Recorrer de manera inversa la tabla
                    props.quotation.loanAmortization
                        .slice()
                        .reverse()
                        .forEach(x => {
                            if (montoPagado <= 0) return;

                            if (x.amortizationPayment.length > 0) {
                                // Revisa que el ultimo pago este en reaming 0
                                if (x.amortizationPayment[x.amortizationPayment.length - 1].paymentRemaining !== 0) {
                                    // console.log("advancePayment TOMAR FILA: ");
                                }
                            }

                            if (x.capital <= montoPagado) {
                                montoPagado -= x.capital;
                                let calAplicado = x.initialCapital < 1 ? 0 : (x.installmentNumber > 0 ? (Math.abs(x.installmentWithVat - x.interest - x.tax)) : x.installmentWithVat);
                                x.paymentMadeA = calAplicado;
                                x.fullpaymentA = calAplicado;
                                x.capitalA = vacio;
                                x.initialCapital = vacio;
                                x.interest = vacio;
                                x.tax = vacio;
                                x.commissions = vacio;
                                x.taxes = vacio;
                                x.capital = vacio;
                                x.remainingPaymentA = vacio;
                                x.finalCapital = vacio;
                                x.interesDetail = interesDetail(x);
                                x.moraDetail = moraDetail(x);
                                x.isPayment = true;
                                // Insertar nueva fila en la tabla reactiva
                                localTable.value.push(x);
                            } else {
                                x.interest = x.initialCapital < 1 ? 0 : ((Math.abs(x.initialCapital - formRef.value?.values?.paymentAmount)) * 0.0125);
                                x.interestA = x.interest;
                                x.tax = x.interest * 0.16;
                                x.taxA = x.tax;
                                x.paymentMadeA = montoPagado;
                                x.capital -= montoPagado;
                                x.capitalPA = x.capital;
                                x.interestPA = interesDetail(x);
                                let operando = Math.abs((x.paymentMadeA + x.capital + interesDetail(x) + 0 + 0) - x.paymentMadeA);
                                x.remainingPaymentA = operando < 0 ? 0 : operando;
                                x.fullpaymentA = x.paymentMadeA + x.remainingPaymentA;
                                x.capitalA = x.remainingPaymentA;
                                x.finalCapital = vacio;
                                x.interesDetail = vacio;
                                x.moraDetail = vacio;
                                montoPagado = 0;
                                x.isPayment = false;
                                localTable.value.push(x);
                            }
                        });

                    localTable.value.sort((a, b) => a.installmentNumber - b.installmentNumber);
                    $toast.info("Calculos aplicados");
                    return;
                }
            }
        }
    }

    $toast.warning("No se puede efectuar este tipo de pago ya que se requiere cubrir en totalidad el pago del mes");
    return;
}


const onSubmit = async (values) => {
    try {
        isClicSave.value = true;
        const paymentData = [];

        localTable.value.forEach( x => {
            let saveData = {};
            saveData.quotationId = x.quotationId;
            saveData.loanAmortizationId = x.id;
            saveData.latePayment = isClickCalculate.value.anticipado ? localTable.value.find(y => y.installmentNumber === x.installmentNumber).moraDetail : readOnlyTable.value[readOnlyTable.value.length - 1].moraDetail;
            saveData.paymentInterest = isClickCalculate.value.anticipado ? localTable.value.find(y => y.installmentNumber === x.installmentNumber).interesDetail : readOnlyTable.value[readOnlyTable.value.length - 1].interesDetail;
            saveData.paymentRemaining = isClickCalculate.value.anticipado ? x.remainingPaymentA : pagoRestanteApagarUpdate(props.amortizatiobPayment[props.amortizatiobPayment.length - 1]);
            saveData.paymentAmount = x.paymentMadeA === undefined ? values.paymentAmount : x.paymentMadeA;
            saveData.paymentDate = values.paymentDate;
            saveData.paymentTime = values.paymentTime;
            saveData.bank = values.bank;
            saveData.reference = values.referenceBank;
            saveData.paymentTypeId = values.paymentType;
            saveData.interestA = x.interestA;
            saveData.taxA = x.taxA;
            saveData.capitalPA = x.capitalPA;
            saveData.interestPA = x.interestPA;
            saveData.fullpaymentA = x.fullpaymentA;
            saveData.capitalA = x.capitalA;

            if (
                (isClickCalculate.value.anticipado && x.isPayment !== undefined) ||
                isClickCalculate.value.normal ||
                isClickCalculate.value.moratorio
            ) {
                paymentData.push(saveData);
            }
        });

        const result = await addPayment(paymentData);
        
        // onSubmit Pago creado exitosamente
        if (result.length > 0) {
            isClickCalculate.value.normal = false;
            isClickCalculate.value.moratorio = false;
            isClickCalculate.value.anticipado = false;
            isClicSave.value = false;
            closeModal();
        }

    } catch (error) {
        console.error('Error al crear el pago:', error);
        error.value = err.message || 'Error al procesar el pago';
    }
};

// Watchers
watch(getError, (newError) => {
    error.value = newError;
});

watch(
    () => props.amortizatiobPayment,
    (newVal) => {
        //localTable.value = JSON.parse(JSON.stringify(newVal));
        localTable.value = [... newVal];
    },
    { immediate: true }
);

/** 🔥 LIMPIAR TODO CUANDO CAMBIE CLIENTE O DISPOSICIÓN 🔥 */
watch(
    () => props.client,
    () => resetAll()
);

watch(
    () => props.disposition,
    () => resetAll()
);

/** 🔥 LIMPIAR SI LA TABLA DE AMORTIZACIÓN LLEGA VACÍA 🔥 */
watch(
    () => props.amortizatiobPayment,
    (newVal) => {
        if (!Array.isArray(newVal) || newVal.length === 0) {
            resetAll();
        } else {
            // Si trae datos, solo actualizamos localTable sin limpiar
            localTable.value = JSON.parse(JSON.stringify(newVal));
        }
    },
    { immediate: true }
);
</script>
<style scoped>
/* tus estilos originales */
.table-container {
    max-height: 400px;
    overflow-y: auto;
}

.table th {
    position: sticky;
    top: 0;
    background-color: #f8f9fa;
}

.summary-card {
    border-left: 4px solid #0d6efd;
}

.highlight-row {
    background-color: #f0f8ff;
}

.modal-header {
    background-color: #f8f9fa;
    border-bottom: 1px solid #dee2e6;
}

.modal-title {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 500;
}

.close {
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
}

/* Contenedor scroll como ya lo tienes */
.table-container {
    max-height: 400px;
    overflow-x: auto;
    overflow-y: auto;
    border: 1px solid #ccc;
}

/* Tabla con bordes completos */
.amortization-table {
    border-collapse: collapse;
    width: 100%;
    font-size: 13px;
}

/* Celdas con borde */
.amortization-table th,
.amortization-table td {
    border: 1px solid #b8b8b8;
    padding: 4px 6px;
    text-align: center;
}

/* Primera fila agrupada (color naranja como Excel) */
.amortization-table thead tr:nth-child(1) th {
    background-color: #d97a00;
    color: white;
    font-weight: bold;
    text-align: center;
    border: 1px solid #9c5c00;
}

/* Segunda fila de encabezados (color azul como Excel) */
.amortization-table thead tr:nth-child(2) th {
    background-color: #1a4f8b;
    color: white;
    font-weight: bold;
    border: 1px solid #0f345a;
}

/* Filas del cuerpo */
.amortization-table tbody tr td {
    background: #fff;
}

/* Hover (no tan fuerte) */
.amortization-table tbody tr:hover {
    background-color: #f2f7ff;
}

/* Encabezados sticky */
.amortization-table thead th {
    position: sticky;
    top: 0;
    z-index: 2;
}
</style>